import './newLabel.scss'
import React from 'react';
import { Col } from 'antd';
import EdenredTypo from '@sharedComponent/typography';
const EdenredNewLabel = () => {
	return (
		<>
        <Col className='edenredLabel'>
        <EdenredTypo className='text'>New</EdenredTypo>
        </Col>
        </>
	);
};

export default EdenredNewLabel;